import { gql } from "@apollo/client"

export const GET_LICENSE_POOLS_LIST = gql`
  query getLicensePoolsList($data: GetLicensePoolsListInput) {
    licensePools {
      getLicensePools(data: $data) {
        licensePools {
          id
          createdAt
          updatedAt
          createdBy
          poolType
          poolCount
          startDate
          endDate
          meta
          externalSourceType
          externalSourceId
          entityType
          entityId
          entityName
          contentText
        }
      }
    }
  }
`

export const GET_ENUMERATIONS = gql`
  query getEnumerations($data: GetEnumerationsInput!) {
    enumerations {
      getEnumerations(data: $data) {
        enumerations {
          id
          display
        }
      }
    }
  }
`
// Workkeys Specific API
export const GET_CONTENT_BUNDLES = gql`
  query getContentBundles($data: GetContentBundlesInput) {
    contentBundles {
      getContentBundles(data: $data) {
        contentBundles {
          id
          displayName
          displayDescription
          createdAt
          updatedAt
          createdBy
          meta
          externalSourceType
          externalSourceId
        }
      }
    }
  }
`
